/** Error codes from Rust / terminal_create that have a readable message (projects.run.errors.*). */
const KNOWN_ERRORS = [
  'port_in_use',
  'no_free_port',
  'not_found',
  'cwd_not_found',
  'cwd_escapes',
  'repo_not_found',
  'repo_not_allowed',
  'unsafe_arg',
  'outside_repo',
  'file_too_large',
  'invalid_json',
  'no_configurations',
  // code_repo_clone.rs (Choose local clone… / Clone here…)
  'code_repo_missing',
  'code_repo_refused',
  'code_repo_not_git',
  'code_repo_bad_url',
  'code_repo_dest_refused',
  'code_repo_dest_not_empty',
  'code_repo_clone_failed',
];

export function errorText(t, raw) {
  const text = String(raw || '');
  const code = KNOWN_ERRORS.find((c) => text === c || text.startsWith(`${c}:`));
  if (!code) return text;
  const detail = text.slice(code.length + 1).trim();
  return t(`projects.run.errors.${code}`, { detail });
}
